module.exports = __webpack_public_path__ + "static/media/hero-title-zh-CN.0f22e285.png";